import { Component, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FaceCompareService } from '../../../../services/face-compare/face-compare.service';

@Component({
  selector: 'app-face-compare-toolbar',
  imports: [CommonModule],
  templateUrl: './face-compare-toolbar.component.html',
  styleUrl: './face-compare-toolbar.component.css',
})
export class FaceCompareToolbarComponent implements OnInit, OnDestroy {
  @Output() splitViewClicked = new EventEmitter<void>();
  @Output() resetAllClicked = new EventEmitter<void>();

  hasImages = false;
  private uploadsSub?: Subscription;

  constructor(
    private router: Router,
    private faceCompareService: FaceCompareService,
  ) {}

  ngOnInit(): void {
    this.uploadsSub = this.faceCompareService.uploadedImages$.subscribe(
      (images) => {
        this.hasImages = images.length > 0;
      },
    );
  }

  ngOnDestroy(): void {
    this.uploadsSub?.unsubscribe();
  }

  openSplitView(): void {
    this.splitViewClicked.emit();
  }

  toggleViewUploads(): void {
    this.faceCompareService.triggerViewUploadsHistory();
    this.router.navigate(['/osint-image-search/face-compare/upload']);
  }

  resetAll(): void {
    this.faceCompareService.clearAll();
    this.resetAllClicked.emit();
    this.router.navigate(['/osint-image-search/face-compare/upload']);
  }
}
